/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';

const useOnArrowKeyDown = (onLeft: () => void, onRight: () => void) => {
    const onKeyDown = (event: KeyboardEvent) => {
        const { keyCode } = event;
        const keyLeft = 37;
        const keyRight = 39;

        if (keyCode === keyLeft) {
            onLeft();
        }
        if (keyCode === keyRight) {
            onRight();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            document.addEventListener('keydown', onKeyDown);

            return () => {
                document.removeEventListener('keydown', onKeyDown);
            };
        }
    }, [onKeyDown]);
};

export default useOnArrowKeyDown;
